export default __webpack_public_path__ + "static/media/buster_klein_24.357226c5.jpg";